import { render, staticRenderFns } from "./crowdPortrait.vue?vue&type=template&id=3fee9e1b&scoped=true"
import script from "./crowdPortrait.vue?vue&type=script&lang=js"
export * from "./crowdPortrait.vue?vue&type=script&lang=js"
import style0 from "./crowdPortrait.vue?vue&type=style&index=0&id=3fee9e1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fee9e1b",
  null
  
)

export default component.exports